import { render, staticRenderFns } from "./ProductEditGeneralInfo.vue?vue&type=template&id=c6e79030&scoped=true&"
import script from "./ProductEditGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./ProductEditGeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProductEditGeneralInfo.vue?vue&type=style&index=0&id=c6e79030&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e79030",
  null
  
)

export default component.exports